import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import {
  APP_CONSTANT,
  excelExportSheetheader,
  INDEX_SCORE_INDICATOR,
} from "../../../../utils/constants";

export const exportToExcel = async (
  data,
  fileName = "gap_analysis.xlsx",
  brandHeader,
  excelExportData,
) => {
  // const strengthData = data[0].strengths;
  // const opportunitiesData = data[0].opportunities;

  // const maxLength = Math.max(strengthData.length, opportunitiesData.length);
  const rows = [];

  // // Header
  // rows.push([
  //   "Strengths",
  //   APP_CONSTANT.CATEGORY_LABEL,
  //   brandHeader,
  //   "Index",
  //   "Opportunities",
  //   APP_CONSTANT.CATEGORY_LABEL,
  //   brandHeader,
  //   "Index",
  // ]);

  rows.push(["", APP_CONSTANT.CATEGORY_LABEL, brandHeader, "Index"]);

  // // Data rows
  // for (let i = 0; i < maxLength; i++) {
  //   const strengthLabel = strengthData[i] ? `${strengthData[i].label}` : "";
  //   const strengthCategory = strengthData[i]
  //     ? `${strengthData[i].category_avg}`
  //     : "";
  //   const strengthBrand = strengthData[i] ? `${strengthData[i].brandVal}` : "";
  //   const strengthValue = strengthData[i] ? `${strengthData[i].value}` : "";
  //   const opportunitiesLabel = opportunitiesData[i]
  //     ? `${opportunitiesData[i].label}`
  //     : "";
  //   const opportunitiesCategory = opportunitiesData[i]
  //     ? `${opportunitiesData[i].category_avg}`
  //     : "";
  //   const opportunitiesBrand = opportunitiesData[i]
  //     ? `${opportunitiesData[i].brandVal}`
  //     : "";
  //   const opportunitiesValue = opportunitiesData[i]
  //     ? `${opportunitiesData[i].value}`
  //     : "";
  //   rows.push([
  //     strengthLabel,
  //     strengthCategory,
  //     strengthBrand,
  //     strengthValue,
  //     opportunitiesLabel,
  //     opportunitiesCategory,
  //     opportunitiesBrand,
  //     opportunitiesValue,
  //   ]);
  // }

  // Loop through each key in the object
  for (const key in excelExportData) {
    if (Array.isArray(excelExportData[key])) {
      // // Loop through each item in the array
      // excelExportData[key].forEach((item, index) => {
      //   console.log(`Item ${index + 1}:`, item);

      //   // Example: access specific properties
      //   console.log('Label:', item.labelTwo);
      //   console.log('Value:', item.value);
      // });
      const datakey = excelExportData[key];
      rows.push([
        `${excelExportSheetheader(key)}\nBase Size (Uses)`,
        datakey[0].categoryBaseSize,
        datakey[0].brandBaseSize,
        "",
      ]);

      for (let i = 0; i < datakey.length; i++) {
        const colLabel = datakey[i] ? `${datakey[i].labelTwo}` : "";
        const colCategory = datakey[i] ? datakey[i].category_avg : "";
        const colBrand = datakey[i] ? datakey[i].brandVal : "";
        const colIndexValue = datakey[i] ? datakey[i].value : "";
        rows.push([colLabel, colCategory, colBrand, colIndexValue]);
      }
      rows.push(["", "", "", ""]);
    }
  }

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Survey Data");

  rows.forEach((rowData, index) => {
    const row = worksheet.addRow(rowData);

    row.eachCell((cell, colNumber) => {
      if (index === 0) {
        cell.font = { bold: true };
      }
      if (colNumber === 1) {
        cell.alignment = { wrapText: true, vertical: "bottom" };
      }
      if (colNumber === 4) {
        const colValue = rowData[3];
        if (
          rowData[0] !== "" &&
          colValue > INDEX_SCORE_INDICATOR.GREEN_TEXT_VALUE
        ) {
          cell.font = { color: { argb: "0a3622" }, bold: true };
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "a3cfbb" }, // Green background
          };
        } else if (
          rowData[0] !== "" &&
          colValue < INDEX_SCORE_INDICATOR.RED_TEXT_VALUE
        ) {
          cell.font = { color: { argb: "58151c" }, bold: true };
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "f8d7da" }, // Red background
          };
        } else {
          cell.font = { bold: true };
        }
        cell.alignment = {
          wrapText: true,
          vertical: "bottom",
          horizontal: "center",
        };
      } else {
        cell.alignment = {
          wrapText: true,
          vertical: "bottom",
          horizontal: "center",
        };
      }

      // Check for "Base Size (Uses)" in the first cell
      if (rowData[0]?.includes("Base Size (Uses)")) {
        cell.font = { color: { argb: "FFFFFFFF" }, bold: true };
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FF000000" }, // Black background
        };
      }
    });

    // Optional: set row height for better visibility
    // row.height = 30;
  });

  worksheet.columns = [
    { width: 40 },
    { width: 30 },
    { width: 30 },
    { width: 10 },
  ];

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  saveAs(blob, fileName);

  // // Create worksheet and workbook
  // const worksheet = XLSX.utils.aoa_to_sheet(rows);
  // const workbook = XLSX.utils.book_new();
  // XLSX.utils.book_append_sheet(workbook, worksheet, "SO_Report");

  // // Write file
  // const wbout = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  // saveAs(new Blob([wbout], { type: "application/octet-stream" }), fileName);
};
